
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import Modal from 'react-modal';
import { useAuthStore, useCarritoClienteStore, useGlobalValueStore, useModalStore } from '../../stores';
import { TablaDeCarritoEnModal } from './components';
import { roleCompra } from '../../data';
import { separadorMillares, usePrecioCarritoXRole } from '../../hooks';
import { useListCarritoXUser } from '../../hooks/cache';
Modal.setAppElement('#root');




export const ModalCarritoCliente = () => {


    const navigate = useNavigate();
    const { view } = useGlobalValueStore();
    const { cliente } = useAuthStore();
    const { data } = useListCarritoXUser(cliente?.id);
    const { items } = useCarritoClienteStore();
    const itemsClienteCarrito = (cliente) ? data : items;
    const { modalLateral, modalToggleLateral } = useModalStore();
    const { precioTotalSegunRol } = usePrecioCarritoXRole();
    

    const handlerComprar = () => {
        navigate('/comprar-cliente');
        modalToggleLateral(false);
    }



    return (
        
        <Modal isOpen={modalLateral} onRequestClose={() => modalToggleLateral(false)} className="modal-custom" 
            style={{ overlay: {zIndex:2000}, content: {zIndex: 2001} }}
        >
            <Typography sx={{fontSize:21, fontWeight:'bold', textAlign:'center', my:2}}>
                Productos del Carrito
            </Typography>

            <TablaDeCarritoEnModal data={itemsClienteCarrito || []} cliente={!cliente} />

            <div className='fin-carrito'>
                {itemsClienteCarrito?.length > 0 &&
                <Grid container sx={{display:'flex', justifyContent:'center'}}>
                    <Typography variant="h3">
                        { `Total ${roleCompra[view]}: $${ separadorMillares(precioTotalSegunRol(itemsClienteCarrito)) }` }
                    </Typography>
                </Grid>
                }

                <Grid container direction="column" sx={{ alignItems:'center', mt:1, mb:3}}>
                    {itemsClienteCarrito?.length > 0 && 
                    <Grid item>
                        <Button variant="outlined" color="secondary" onClick={handlerComprar} fullWidth sx={{minWidth:'200px'}}>
                            Verificar
                        </Button>
                    </Grid>
                    }
                    <Grid item>
                        <Button variant="outlined" color="primary" onClick={() => modalToggleLateral(false)} fullWidth sx={{minWidth:'200px'}}>
                            Salir
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </Modal>
    )
}
